export default "__VITE_ASSET__rJ_ksRZQ__"